import { render, staticRenderFns } from "./AdvertGroup.vue?vue&type=template&id=2d3c2a6d&scoped=true&"
import script from "./AdvertGroup.vue?vue&type=script&lang=js&"
export * from "./AdvertGroup.vue?vue&type=script&lang=js&"
import style0 from "./AdvertGroup.vue?vue&type=style&index=0&id=2d3c2a6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c2a6d",
  null
  
)

export default component.exports